import React from 'react';
import Svg, { Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';
import PropTypes from 'prop-types';
import { PALETTE } from '../../../constants';

const QuestionDarkIcon = (props) => {
  const {
    color,
    ...svgProps
  } = props;
  return(
    <Svg {...svgProps} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <Path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C0 5.37273 5.37273 0 12 0C18.6273 0 24 5.37273 24 12C24 18.6273 18.6273 24 12 24C5.37273 24 0 18.6273 0 12ZM10.909 18.5455C10.909 17.9122 11.371 17.4545 11.9999 17.4545C12.6653 17.4545 13.0908 17.9122 13.0908 18.5455C13.0908 19.1613 12.6653 19.6364 11.9999 19.6364C11.353 19.6364 10.909 19.1613 10.909 18.5455ZM9.31151 6.54253C9.31151 6.54253 10.7652 5.45455 12.3354 5.45455C14.9318 5.45455 16.1455 7.30747 16.1455 8.73606C16.1455 10.0142 15.2074 10.9048 14.0687 11.9158C13.1479 12.7319 13.0582 13.9842 13.0582 13.9842C13.0273 14.2695 13.0081 14.6199 13.0157 14.8515C13.0233 15.083 12.7994 15.2727 12.5178 15.2727H11.5488C11.2672 15.2727 11.021 15.1073 11.0018 14.9047C10.9825 14.7021 10.9683 14.375 10.9704 14.0876C10.9704 14.0876 10.9815 12.1339 12.1105 11.0061C12.4185 10.7041 12.6943 10.477 12.9291 10.2837C13.4692 9.8391 13.7927 9.57277 13.7927 8.98312C13.7927 8.24091 13.348 7.59691 11.9459 7.68064C11.1345 7.72923 10.0566 8.27864 10.0566 8.27864C9.80485 8.40682 9.50803 8.2957 9.3966 8.0321L9.1013 7.33125C8.98987 7.06713 9.08458 6.71257 9.31151 6.54253Z" fill={color}/>
    </Svg>
  )
}

QuestionDarkIcon.defaultProps = {
  height: 24,
  width: 24,
  color: PALETTE.warning,
};

QuestionDarkIcon.PropTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
}

export default pure(QuestionDarkIcon);